import { useCallback, useEffect, useState } from "react"

import useGetUserPushConfigQuery from "hooks/queries/user/useGetUserPushConfigQuery"
import useUpdateUserPushConfigMutate from "hooks/queries/user/useUpdateUserPushConfigMutate"

const usePushConfig = ({ userNo }) => {
  const [pushConfigData, setPushConfigData] = useState(null)

  const { mutate: updatePushConfigMutate, isLoading: isUpdating } =
    useUpdateUserPushConfigMutate(userNo)
  const { data, isLoading } = useGetUserPushConfigQuery(userNo, {
    enabled: !!userNo,
  })

  const updatePushConfigData = useCallback(
    (payload) => {
      updatePushConfigMutate(payload, {
        onSuccess: (result) => {
          const pushConfig = result.data.updated_item[0]
          setPushConfigData((prevData) => ({ ...prevData, ...pushConfig }))
        },
      })
    },
    [updatePushConfigMutate]
  )

  const handleChangePushConfig = useCallback(
    (e) => {
      if (isUpdating) return
      const { name, checked } = e.target
      const payload = {}
      if (name === "feed_alarm") {
        payload.task_like = checked
        payload.task_comment = checked
        payload.task_comment_reply = checked
      } else if (name === "community_alarm") {
        payload.community_post_new = checked
        payload.community_post_like = checked
        payload.community_post_comment = checked
        payload.community_post_comment_reply = checked
      } else {
        payload[name] = checked
      }

      updatePushConfigData(payload)
    },
    [updatePushConfigData, isUpdating]
  )

  useEffect(() => {
    if (data) {
      const { push_config: pushConfig } = data.data
      setPushConfigData(pushConfig)
    }
  }, [data])

  return { pushConfigData, isLoading, handleChangePushConfig }
}

export default usePushConfig
